import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--canvas)]">
        <div className="text-[var(--ink-muted)] text-sm tracking-wide" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (role && !roleSatisfies(user.role, role)) {
    return <Navigate to="/app" replace />;
  }
  return children;
}

function roleSatisfies(userRole, requiredRole) {
  const rank = { writer: 1, admin: 2, super_admin: 3 };
  return (rank[userRole] || 0) >= (rank[requiredRole] || 0);
}
